import {
  emailRegEx,
  phoneRegEx,
  websiteRegex,
  zipCodeRegEx,
} from 'utils/RegularExpressions';
import * as Yup from 'yup';

const step1Schema = Yup.object({
  applicantInfo: Yup.object({
    fullName: Yup.string()
      .required('Required')
      .max(250, 'Must be less than 250 characters.'),
    contactEmail: Yup.string()
      .required('Required')
      .matches(emailRegEx, 'Please enter a valid email address'),
    contactPhone: Yup.string().required('Required').matches(phoneRegEx, {
      excludeEmptyString: true,
      message: 'Please enter a valid phone number',
    }),
  }),
});

const step2Schema = Yup.object({
  programEligibility: Yup.object({
    address: Yup.string()
      .max(250, 'Must be less than 250 characters.')
      .required('Required'),
    city: Yup.string()
      .max(250, 'Must be less than 250 characters.')
      .required('Required'),
    state: Yup.string().required('Required'),
    zipCode: Yup.string()
      .required('Required')
      .typeError('Must be a number')
      .matches(zipCodeRegEx, {
        excludeEmptyString: true,
        message: 'Please enter a valid Zip / Postal code',
      }),
    q1: Yup.string().required('Required'),
    q2: Yup.string().required('Required'),
    householdSize: Yup.string()
      .max(250, 'Must be less than 250 characters.')
      .required('Required'),
    householdIncome: Yup.string()
      .max(250, 'Must be less than 250 characters.')
      .required('Required'),
    q3: Yup.string().required('Required'),
  }),
});

const step3Schema = Yup.object({
  demographics: Yup.object({
    ethnicity: Yup.array().min(1, 'Required'),
    householdHead: Yup.array().min(1, 'Required'),
  }),
});

const step4Schema = Yup.object({
  requestedRepairs: Yup.object({
    options: Yup.array().min(1, 'Required'),
  }),
});

export const validationSchema = [
  step1Schema,
  step2Schema,
  step3Schema,
  step4Schema,
];

export const CRP2022ValidationSchema = [
  step1Schema,
  step2Schema,
  step3Schema,
  step4Schema,
];
